import React from 'react';
import StepHorizontalDoubleFieldItem from './StepHorizontalDoubleFieldItem';

export default class StepHorizontalDoubleField extends React.Component {
    static defaultProps = {
        inputTips: []
    }

    render() {
        if (this.props.visible === false) {
            return <React.Fragment></React.Fragment>
        }

        let classNames = this.hasMultipleFields() ? 'heating-horizontal-double-field multiple-items' : 'configuration-field-container single-item';
        classNames += ' ' + 'double-field-wrapper';

        if (this.props.className) {
            classNames += ' ' + this.props.className
        }
        if (this.props.readonly) {
            classNames += ' ' + '--readonly'
        }

        return (
            <div className={classNames}>
                {this.props.children}
                <div className="configuration-field-row">
                    <div className="field-column1" style={{width: '40%'}}/>
                    <div className="field-column23" style={{width: '40%'}}>
                        {this.renderTips()}
                    </div>
                </div>
                {this.props.renderAdditionalFilters && <div className="configuration-field-row">
                    <div className="field-column1" style={{width: '40%'}}/>
                    <div className="field-column23" style={{width: '60%'}}>
                        {this.props.renderAdditionalFilters()}
                    </div>
                </div>}
            </div>
        )
    }

    hasMultipleFields = () => this.props.children.filter(x => React.isValidElement(x) && x.type === StepHorizontalDoubleFieldItem).length > 1;

    renderTips() {
        if (this.props.inputTips.length === 0) {
            return <React.Fragment></React.Fragment>;
        }

        return (
            <div className="field-tips">
                {this.props.inputTips.map((tip, idx) => (
                    <div key={idx}>{tip}</div>
                ))}
            </div>
        )
    }
}